// Help analytics capture (Task #2088).
//
// Thin fire-and-forget wrapper around the tenant-scoped hand-rolled
// `POST /api/help/events` endpoint (out of OpenAPI — same pattern as the
// platform consoles). Analytics must never break the UX: every failure is
// swallowed silently.
import { customFetch } from "@workspace/api-client-react";

export type HelpEventType =
  | "article_view"
  | "search"
  | "search_zero_results"
  | "help_opened_from_error"
  | "walkthrough_completed"
  | "walkthrough_skipped"
  | "walkthrough_started"
  | "article_vote"
  | "context_link_click";

export interface HelpEvent {
  eventType: HelpEventType;
  articleId?: string;
  query?: string;
  resultCount?: number;
  walkthroughId?: string;
  /** Free-text context, e.g. "drawer", "help-centre", "helpful". */
  context?: string;
}

export function recordHelpEvent(event: HelpEvent): void {
  void customFetch("/api/help/events", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(event),
  }).catch(() => {
    /* analytics are best-effort — never surface an error */
  });
}

/** Fetch the caller's current helpful/not-helpful vote for an article. */
export async function fetchMyArticleVote(articleId: string): Promise<string | null> {
  try {
    const res = await customFetch<{ vote: string | null }>(
      `/api/help/articles/${encodeURIComponent(articleId)}/my-vote`,
    );
    return res.vote ?? null;
  } catch {
    return null;
  }
}
